import { render, staticRenderFns } from "./SettingRadio.pug?vue&type=template&id=a6af8e04&scoped=true&lang=pug&"
import script from "./SettingRadio.vue?vue&type=script&lang=js&"
export * from "./SettingRadio.vue?vue&type=script&lang=js&"
import style0 from "./SettingRadio.vue?vue&type=style&index=0&id=a6af8e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6af8e04",
  null
  
)

export default component.exports